import { AppState } from '../index';

export const getCategoryById =
  (categoryId: number | undefined) => (state: AppState) => {
    return categoryId ? state.catalogue.categories?.[categoryId] : undefined;
  };
